module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pages"
  }, [_c('div', {
    staticClass: "index-wapper"
  }, [_c('aside', {
    staticClass: "nav",
    class: {
      'close': _vm.switchOff
    }
  }, [_c('z-menu')], 1), _vm._v(" "), _c('header', {
    staticClass: "hearder-top fx fx-x-between fx-y-center",
    class: {
      'close': _vm.switchOff
    }
  }, [_c('div', {
    staticClass: "fx fx-y-center"
  }, [_c('a', {
    staticClass: "switch icon-menu-l ",
    on: {
      "click": _vm.handleSwitch
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "user-operation"
  }, [_c('a', {
    on: {
      "click": _vm.handleOutLogin
    }
  }, [_c('i', {
    staticClass: "icon-out m-r-5"
  }), _vm._v("退出")])])]), _vm._v(" "), _c('article', {
    staticClass: "container",
    class: {
      'close': _vm.switchOff
    }
  }, [_c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [_c('router-view', {
    staticClass: "view"
  })], 1)], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-339f426a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/_vue-loader@12.2.2@vue-loader/lib/selector.js?type=template&index=0!./src/views/mg/Main.vue
// module id = 828
// module chunks = 0